// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TemplatesPage from "./pages/TemplatesPage";
import EditorPage from "./pages/EditorPage";
import GuestsPage from "./pages/GuestsPage";
import {PreviewPage} from "./pages/PreviewPage";
import LoginPage from "./pages/LoginPage";
import {EventManagerPage} from "./pages/EventManagerPage";
import { GuestManagerPage } from "./pages/GuestManagerPage";
import { EventHubPage } from "./pages/EventHubPage";
import InviteThemeRenderer from "./pages/InviteThemeRenderer";
import { GroupCeremonyPagesPage } from "./pages/GroupCeremonyPagesPage";
import { EventThemePage } from "./pages/EventThemePage";
import { AuthProvider } from './contexts/AuthContext';
import { AppLayout } from './layouts/AppLayout';
import DiscoveryPage from "./pages/DiscoveryPage";
import AdminTemplateMetadataPage from "./pages/AdminTemplateMetadataPage";
import AdminAiTemplateCreatePage from "./pages/AdminAiTemplateCreatePage";
import AdminAssetLibraryPage from "./pages/AdminAssetLibraryPage";
import AdminRoute from "./components/AdminRoute";




export default function App() {
  return (
    <AuthProvider>
    <Router>
      <div style={{ fontFamily: "sans-serif", minHeight: "100vh", background: "#fafafa" }}>
        <Routes>
          {/* Discovery home */}
          <Route path="/" element={
                                              <AppLayout>
                                                <DiscoveryPage />
                                              </AppLayout>
                                            } />

          {/* Template selection page */}
          <Route path="/templates" element={
                                              <AppLayout>
                                                <TemplatesPage />
                                              </AppLayout>
                                            } />
          <Route path="/discovery" element={
                                              <AppLayout>
                                                <DiscoveryPage />
                                              </AppLayout>
                                            } />  

          {/* Polotno editor page */}
          <Route path="/editor/:templateId" element={<EditorPage />} />

          {/* Guest management page */}
          <Route path="/guests/:eventId" element={
                                                      <AppLayout>
                                                        <GuestsPage />
                                                      </AppLayout>
                                                } />

          <Route path="/preview/:Id" element={<PreviewPage />} />
          <Route path="/events/:eventId/group-pages" element={
                                                      <AppLayout>
                                                        <GroupCeremonyPagesPage />
                                                      </AppLayout>
                                                } />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/event-manager" element={
                                                      <AppLayout>
                                                        <EventManagerPage />
                                                      </AppLayout>
                                                } />
          <Route path="/event-theme" element={
                                                      <AppLayout>
                                                        <EventThemePage />
                                                      </AppLayout>
                                                } />
          <Route path="/guest-manager" element={
                                                      <AppLayout>
                                                        <GuestManagerPage />
                                                      </AppLayout>
                                                } />
          {/* ✅ Add this route for invite token links */}
          <Route path="/invite/:token" element={<InviteThemeRenderer />} />
          <Route path="/events/:eventId/experience" element={<InviteThemeRenderer />} />
          <Route path="/events/:eventId/guest-preview/:eventGuestId" element={<InviteThemeRenderer />} />

          <Route path="/dashboard" element={
                                                      <AppLayout>
                                                        <EventHubPage />
                                                      </AppLayout>
                                                } />
          <Route path="/admin/templates" element={
                                                      <AppLayout>
                                                        <AdminRoute>
                                                          <AdminTemplateMetadataPage />
                                                        </AdminRoute>
                                                      </AppLayout>
                                                } />
          <Route path="/admin/templates/ai-create" element={
                                                      <AppLayout>
                                                        <AdminRoute>
                                                          <AdminAiTemplateCreatePage />
                                                        </AdminRoute>
                                                      </AppLayout>
                                                } />
          <Route path="/admin/assets" element={
                                                      <AppLayout>
                                                        <AdminRoute>
                                                          <AdminAssetLibraryPage />
                                                        </AdminRoute>
                                                      </AppLayout>
                                                } />


          {/* 404 fallback */}
          <Route path="*" element={<h2 style={{ textAlign: "center", padding: "2rem" }}>Page Not Found</h2>} />
        </Routes>
      </div>
    </Router>
    </AuthProvider>
  );
}
